// Mapping de aerolíneas → datos de check-in.
// `checkinUrl` abre la página de check-in (algunas aceptan params, otras no — el PNR
// queda en el portapapeles para pegar).
// `name` matchea contra el campo flight.airline (case-insensitive, normalizado).
const AIRLINES = [
  {
    match: ["iberia", "ib", "iberia express"],
    name: "Iberia",
    checkinUrl: "https://www.iberia.com/web/checkin.do",
    opensHoursBefore: 48,
    color: "#D7192D",
    site: "iberia.com",
  },
  {
    match: ["air europa", "aireuropa", "ux"],
    name: "Air Europa",
    checkinUrl: "https://checkin.aireuropa.com/cki/inicio.do?_lang=es",
    opensHoursBefore: 36,
    color: "#0033A0",
    site: "aireuropa.com",
  },
  {
    match: ["wizz", "wizz air", "w6"],
    name: "Wizz Air",
    checkinUrl: "https://wizzair.com/en-gb/check-in",
    opensHoursBefore: 48,
    color: "#C6007E",
    site: "wizzair.com",
  },
  {
    match: ["ryan", "ryanair", "fr"],
    name: "Ryanair",
    checkinUrl: "https://www.ryanair.com/es/es/check-in",
    opensHoursBefore: 24,
    color: "#073590",
    site: "ryanair.com",
  },
  {
    match: ["smart wings", "smartwings", "smart wong", "qs"],
    name: "Smartwings",
    checkinUrl: "https://www.smartwings.com/en/check-in/",
    opensHoursBefore: 36,
    color: "#FFC72C",
    site: "smartwings.com",
  },
  {
    match: ["latam", "lan", "la"],
    name: "LATAM",
    checkinUrl: "https://www.latamairlines.com/cl/es/checkin",
    opensHoursBefore: 48,
    color: "#152939",
    site: "latam.com",
  },
  {
    match: ["sky airline", "skyairline", "h2"],
    name: "Sky Airline",
    checkinUrl: "https://www.skyairline.com/checkin",
    opensHoursBefore: 24,
    color: "#003DA5",
    site: "skyairline.com",
  },
  {
    match: ["el al", "elal", "ly"],
    name: "El Al",
    checkinUrl: "https://www.elal.com/en/passenger-info/at-the-airport/online-check-in/",
    opensHoursBefore: 24,
    color: "#0033A0",
    site: "elal.com",
  },
  {
    match: ["lufthansa", "lh"],
    name: "Lufthansa",
    checkinUrl: "https://www.lufthansa.com/online-checkin/",
    opensHoursBefore: 23,
    color: "#05164D",
    site: "lufthansa.com",
  },
];

const FALLBACK = {
  match: [],
  name: "Aerolínea",
  checkinUrl: "https://www.google.com/search?q=check-in+",
  opensHoursBefore: 24,
  color: "#888",
  site: "",
};

function norm(s) {
  return (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();
}

export function getAirlineInfo(airlineName) {
  const n = norm(airlineName);
  if (!n) return { ...FALLBACK };
  const hit = AIRLINES.find((a) => a.match.some((m) => n.includes(m)));
  if (hit) return hit;
  return { ...FALLBACK, checkinUrl: `https://www.google.com/search?q=check-in+${encodeURIComponent(airlineName)}` };
}

/** Returns hours until departure date (string ISO). Negative if past. */
export function hoursUntil(isoDate) {
  if (!isoDate) return null;
  const t = new Date(isoDate).getTime();
  if (Number.isNaN(t)) return null;
  return (t - Date.now()) / (1000 * 60 * 60);
}

/** Returns:
 *  - "open" → check-in already open
 *  - "soon" → opens within 24h
 *  - "later" → opens in more than 24h
 *  - "closed" → flight already departed
 */
export function checkinStatus(flight) {
  const hrs = hoursUntil(flight?.depart);
  if (hrs == null) return "later";
  if (hrs < 0) return "closed";
  const info = getAirlineInfo(flight?.airline);
  if (hrs <= info.opensHoursBefore) return "open";
  if (hrs - info.opensHoursBefore <= 24) return "soon";
  return "later";
}
